import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressMarketAimApiEmbeddedScriptsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/app-instance-manager-webapp',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/apps',
        destPath: '',
      },
    ],
    'wixapis.com': [
      {
        srcPath: '/apps',
        destPath: '',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
      {
        srcPath: '/api/v1/instance',
        destPath: '/v1/instance',
      },
      {
        srcPath: '/api/v1/scripts',
        destPath: '/v1/scripts',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/app-instance-manager',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/devcenter/app-instance/v1/instance',
        destPath: '/v1/instance',
      },
      {
        srcPath: '/devcenter/checkout/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/devcenter/checkout/v1/metered-billing-charges',
        destPath: '/v1/metered-billing-charges',
      },
      {
        srcPath: '/devcenter/scripts/v1/scripts',
        destPath: '/v1/scripts',
      },
      {
        srcPath: '/market/aim/v1/billing-event',
        destPath: '/v1/billing-event',
      },
      {
        srcPath: '/devcenter/bi-events/v1/bi-event',
        destPath: '/v1/bi-event',
      },
    ],
    _: [
      {
        srcPath: '/devcenter/app-instance/v1/instance',
        destPath: '/v1/instance',
      },
      {
        srcPath: '/devcenter/checkout/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/devcenter/checkout/v1/metered-billing-charges',
        destPath: '/v1/metered-billing-charges',
      },
      {
        srcPath: '/devcenter/scripts/v1/scripts',
        destPath: '/v1/scripts',
      },
      {
        srcPath: '/market/aim/v1/billing-event',
        destPath: '/v1/billing-event',
      },
      {
        srcPath: '/devcenter/bi-events/v1/bi-event',
        destPath: '/v1/bi-event',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_app-management_embedded-scripts';

/**
 * Inserts custom script tags into a site, with the specified values for any dynamic parameters. Call this method when your app is installed on a site.
 *
 * Your app must have an existing
 * [embedded script component](https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/embedded-scripts/about-embedded-scripts),
 * with exactly matching parameter names.
 */
export function embedScript(payload: object): RequestOptionsFactory<any> {
  function __embedScript({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.devcenter.scripts.v1.script_properties',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.market.aim.api.EmbeddedScriptsService.EmbedScript',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressMarketAimApiEmbeddedScriptsServiceUrl({
        protoPath: '/v1/scripts',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __embedScript;
}

/**
 * Retrieves information about your app's existing embedded script.
 *
 * If your app doesn't have an embedded script on the relevant site, a `404` error is returned.
 */
export function getEmbeddedScript(payload: object): RequestOptionsFactory<any> {
  function __getEmbeddedScript({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.devcenter.scripts.v1.script_properties',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.market.aim.api.EmbeddedScriptsService.GetEmbeddedScript',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressMarketAimApiEmbeddedScriptsServiceUrl({
        protoPath: '/v1/scripts',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getEmbeddedScript;
}
